import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import api from '../utils/api';

export function useModules(studentId, courseId) {
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const prevStudentId = useRef(studentId);
  const prevCourseId = useRef(courseId);

  // Clear modules synchronously before render when student or course changes
  useLayoutEffect(() => {
    if (prevStudentId.current !== studentId || prevCourseId.current !== courseId) {
      setModules([]);
      setError(null);
      // Set loading true if we have valid IDs (will fetch), false otherwise
      setLoading(!!(studentId && courseId));
      prevStudentId.current = studentId;
      prevCourseId.current = courseId;
    }
  }, [studentId, courseId]);

  useEffect(() => {
    if (!studentId || !courseId) {
      return;
    }

    const fetchModules = async () => {
      try {
        setLoading(true);
        const response = await api.get(
          `/parent/children/${studentId}/courses/${courseId}/modules`
        );
        setModules(response.data.modules || []);
        setError(null);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to fetch modules');
        setModules([]);
      } finally {
        setLoading(false);
      }
    };

    fetchModules();
  }, [studentId, courseId]);

  return { modules, loading, error };
}
